import getCustomHiddenFields from "../customHiddenFields";
import getHiddenFields from "../hiddenFields";
import { setLeadCookie } from "./prefillLeadData";
import { setFormFieldsValues } from "./formHelpers";
import { handleFocusEvents, handleValueChanges } from "./eventHandlers";
import { isValid } from "./validation";

export default function() {
    const form = el.querySelector("form");
    const formElements = form.elements;

    if (!form || !formElements) return;

    handleFocusEvents(form);
    handleValueChanges(form);

    form.addEventListener("submit", (e) => {
        e.preventDefault();

        const customHiddenFields = getCustomHiddenFields();
        const hiddenFields = getHiddenFields();

        setFormFieldValues(formElements, customHiddenFields);
        setFormFieldsValues(formElements, hiddenFields);

        if (isValid(form, formElements)) {
            setLeadCookie(formElements);
            form.submit();
        }
    });
}
